import { Breadcrumbs, Typography } from '@scale/scaleui';
import { SquadType } from '@scale/shared/types/expertManagement';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  useUserInfoStore,
  userInfoSelector,
} from 'react-scale/components/ExpertManagement/stores/userInfo.store';
import {
  Routes,
  buildRoute,
  removeTrailingBackslash,
} from 'react-scale/components/ExpertManagement/urls';
import { shallow } from 'zustand/shallow';

export const TeamLeadBreadCrumbs: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const maybeUserInfo = useUserInfoStore(userInfoSelector, shallow);
  const userInfo = maybeUserInfo!;
  const steps = useMemo(() => {
    const steps: { label: string; active: boolean; onClick?: () => void }[] = [
      {
        label: userInfo.teamLeadPodType.name,
        onClick: () =>
          history.push(
            removeTrailingBackslash(
              location.pathname +
                buildRoute(Routes.ExpertManagement, {
                  podType: userInfo.teamLeadPodType._id,
                }),
            ),
          ),
        active: false,
      },
    ];

    if (userInfo.manager?.manager) {
      steps.push({
        label: userInfo.manager.manager.name + ' (TLC)',
        onClick: () =>
          history.push(
            removeTrailingBackslash(
              location.pathname +
                buildRoute(Routes.ExpertManagement, { user: userInfo.manager!.manager!.id }),
            ),
          ),
        active: false,
      });
    }

    if (userInfo.manager) {
      steps.push({
        label: userInfo.manager.name + (userInfo.manager.manager ? ' (TL)' : ' (TLC)'),
        onClick: () =>
          history.push(
            removeTrailingBackslash(
              location.pathname +
                buildRoute(Routes.ExpertManagement, { user: userInfo.manager!.id }),
            ),
          ),
        active: false,
      });
    }

    const nameToShow =
      userInfo.squadType === SquadType.Community ? userInfo.squadName : userInfo.name;

    steps.push({
      label:
        nameToShow +
        (userInfo.manager?.manager ? ' (Expert)' : userInfo.manager ? ' (TL)' : ' (TLC)'),
      active: true,
    });

    return steps;
  }, [history, location.pathname, userInfo]);

  return (
    <Typography.H4>
      <Breadcrumbs steps={steps} />
    </Typography.H4>
  );
};
